import { Image } from 'antd-mobile'
import { AddSquareOutline } from 'antd-mobile-icons'
import { isEmpty } from 'lodash-es'
import { useLocalStore, observer, useLocalObservable } from 'mobx-react-lite'
import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import usePopup from '@/components/NewEditForm/UILibrary/HYBVant/HPopup/hooks/usePopup'
import jobStore from '@/store/components/entryJob'

import getQuery from '@/utils/getQuery'

import { HBlockAdd } from '../../HYBVant'

import LongPopup from './LongPopup'
import Popup from './Popup'
import useLocalRewardPunishment from './useLocalRewardPunishment'
import useRewardPunishment from './useRewardPunishment'
import './index.less'

export const Template = (props: any) => {
  const {
    list = [],
    popup,
    tstr: { i = 'full_name', ii = 'relationship', iii = 'contact_number' }
  } = props
  return (
    <div className='hyb-com-concat-content-wrapper'>
      {list.map((x: any, index: number) => (
        <div key={`${x.name}-${index}`} className='hyb-com-concat-content'>
          <div className='hyb-com-concat-content-col-1'>
            <div className='hyb-com-concat-content-1'>
              {x?.[i]} {x?.[ii] && <span> ({x?.[ii]}) </span>}
            </div>
            <div className='education-content-2'>{x?.[iii]}</div>
          </div>
          <div className='hyb-com-concat-content-col-2'>
            <Image
              onClick={() => popup?.(index)}
              className='hyb-com-concat-content-col-2-img'
              src='https://s.huiyunban.cn/1747191709529280512.png'
            />
          </div>
        </div>
      ))}
    </div>
  )
}

const LocalConcat: React.FC<any> = observer(({ onConfirm, value }) => {
  const { concat = [], changeConcatStatus, changeConcat } = useLocalStore(() => jobStore)

  const { open, modalData, onCancel, onOpen } = usePopup({})

  const add = () => {
    changeConcatStatus('Add')
    onOpen({ status: 'Add' })
  }

  const edit = (index: number) => {
    concat.map((x, i) => {
      if (index === i) {
        x.active = 1
      } else x.active = 0
      return x
    })
    changeConcatStatus('Edit')
    onOpen({ status: 'Edit' })
  }

  useEffect(() => {
    if (onConfirm) onConfirm(concat)
  }, [concat])

  useEffect(() => {
    if (value && Array.isArray(value)) {
      !value.some((x) => concat.includes(x)) && changeConcat(value)
    }
  }, [value])

  return (
    <div className='hyb-com-concat'>
      {!isEmpty(concat) && <Template list={concat} popup={edit} tstr={{}} />}
      <HBlockAdd text='添加紧急联系人' onClick={add} />

      {open && <Popup visible={open} onCancel={onCancel} modalData={modalData} />}
    </div>
  )
})
const LongTerm: React.FC<any> = observer(({ isLocalObserver, onConfirm, value, isAuth, title }) => {
  const staffId = decodeURIComponent(getQuery('staffId') || '')
  const { employeeIds } = useLocalObservable(() => jobStore)
  const staff_id = employeeIds?.[0] || staffId
  const local = useLocalRewardPunishment({
    onConfirm,
    value
  })
  const remote = useRewardPunishment({
    onConfirm,
    value
  })
  const {
    add,
    edit,
    open,
    modalData,
    onCancel,
    runDeleteHrmContact,
    runSaveContact,
    deleteHrmContactLoading,
    saveContactLoading
  } = isLocalObserver ? local : remote
  return (
    <>
      {title && (
        <div className='form-title-wrapper'>
          <div className='form-title'>{title}</div>
        </div>
      )}
      <div className='health_certificate'>
        {!isEmpty(value) && (
          <div className='health_certificate-content-wrapper'>
            {value?.map((x: any, index: number) => (
              <div
                key={x}
                className='health_certificate-content'
                onClick={() => isAuth && edit(index)}
              >
                <div className='health_certificate-content-col-1'>
                  <div className='health_certificate-content-1'>
                    {x?.full_name || '-'}
                    {x?.relationship ? ` (${x?.relationship}) ` : ''}
                  </div>
                  <div className='health_certificate-content-3'>{x?.contact_number || '-'}</div>
                </div>
                <div className='health_certificate-content-col-2'>
                  {isAuth && (
                    <Image
                      className='hyb-com-concat-content-col-2-img'
                      src='https://s.huiyunban.cn/1747191709529280512.png'
                    />
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
        {isAuth && <HBlockAdd text='添加紧急联系人' onClick={add} />}
        {open && (
          <LongPopup
            visible={open}
            onCancel={onCancel}
            modalData={{
              ...modalData,
              staff_id,
              runDeleteHrmContact,
              runSaveContact,
              deleteHrmContactLoading,
              saveContactLoading
            }}
          />
        )}
      </div>
    </>
  )
})
const ConcatBox: React.FC<any> = ({
  onConfirm,
  value,
  isLocalObserver = true,
  isAuth = true,
  ...restProps
}) => {
  const location = useLocation()
  return isLocalObserver && location.pathname !== '/entry/stay/addEmployees' ? (
    <LocalConcat onConfirm={onConfirm} value={value} isAuth={isAuth} />
  ) : (
    <LongTerm
      isLocalObserver={isLocalObserver}
      onConfirm={onConfirm}
      value={value}
      isAuth={isAuth}
      {...restProps}
    />
  )
}
export default ConcatBox
